<script lang="ts">
  import { formatOrderFulfillmentDate } from "@shared/svelte/Components/DateFormatter/LocaleString.svelte";
  import { getDateString } from "@retailer/services/order_fulfillment_service";
  import type { TimeSlotType } from "@shared/types/Cart";

  export let dates: Date[];
  export let onDateSelect: (orderWarehouseId: number, selectedDate: Date) => void;
  export let timeSlots: TimeSlotType[];
  export let onTimeSelect: (orderWarehouseId: number, selectedTime: string) => void;
  export let orderWarehouseId: number;
  export let OHLQOrderPaymentMethodsEnabled: boolean;
  export let showTimeSelect: boolean;
  export let distributorUsesWineCellar: boolean = false;

  const dateToDisplay = date =>
    OHLQOrderPaymentMethodsEnabled && distributorUsesWineCellar
      ? date
      : formatOrderFulfillmentDate(date);

  const onDateSelectChange = (orderWarehouseId, selectedDate) => {
    let date;
    if (showTimeSelect) {
      date = getDateString(timeSlots, selectedDate);
      selectedTime = times[0];
    } else {
      date = selectedDate;
    }
    onDateSelect(orderWarehouseId, date);
  };

  let times = [];
  let selectedDate = dates[0];
  let selectedTime = showTimeSelect ? times[0] : [];
  $: times =
    showTimeSelect && timeSlots?.length
      ? timeSlots
          .filter(slot => slot.date.formattedDate === selectedDate)
          .map(slot => slot.specificTimes.map(time => time.twelveHour))
          .flat()
      : [];
</script>

<div style={showTimeSelect ? "width: 50%;" : ""}>
  <select
    class="fizz-select full-width"
    class:fizz-stack-8={!OHLQOrderPaymentMethodsEnabled}
    class:fizz-stack-24={OHLQOrderPaymentMethodsEnabled}
    name="Select fulfillment date"
    data-testid="fulfillment-date-select-{orderWarehouseId}"
    bind:value={selectedDate}
    on:change={() => onDateSelectChange(orderWarehouseId, selectedDate)}
  >
    {#each dates as date}
      <option value={date}>
        {dateToDisplay(date)}
      </option>
    {/each}
  </select>
</div>

{#if showTimeSelect}
  <div style="width: 50%;">
    <select
      class="fizz-select full-width fizz-stack-24"
      name="Select fulfillment time"
      data-testid="fulfillment-time-select-{orderWarehouseId}"
      bind:value={selectedTime}
      on:change={() => onTimeSelect(orderWarehouseId, selectedTime)}
    >
      {#each times as time}
        <option value={time}>
          {time}
        </option>
      {/each}
    </select>
  </div>
{/if}
